// extracted by mini-css-extract-plugin
export default {"root":"IconFire_root__fWyeW"};